import { CardDetailDtoLimited, VoucherType } from 'store/api-slice/types'
import { AmountVoucher } from 'components/shared/Vouchers/AmountVoucher'
import ProductVoucher from 'components/shared/Vouchers/ProductVoucher'
import { CardPersonDto } from 'store/api-slice/hooks'

interface VoucherPreviewProps {
    voucherSignature: string
    unitPrice: number
    voucherType?: VoucherType
    voucherDetails?: CardDetailDtoLimited
    personDetail?: CardPersonDto | undefined
}

const VoucherPreview = ({
    voucherSignature,
    unitPrice,
    voucherType = 'amount',
    voucherDetails,
    personDetail,
}: VoucherPreviewProps) => {
    const isProductVoucher = voucherType === 'product'

    return (
        <>
            {isProductVoucher && voucherDetails && personDetail ? (
                <ProductVoucher
                    voucherSignature={voucherSignature}
                    voucherModel={{
                        personDetail,
                        cardType: voucherDetails.cardType,
                    }}
                />
            ) : (
                <AmountVoucher
                    voucherSignature={voucherSignature}
                    unitPrice={unitPrice}
                />
            )}
        </>
    )
}

export default VoucherPreview
